import { Text } from '@oneaudi/unified-web-components';

export function TextFromHtml({ html }: { html: string }) {
	return (
		<Text variant={{ type: 'copy', order: '1', style: 'normal' }}>
			<span className="[p:first-child:mt-0] block" dangerouslySetInnerHTML={{ __html: html }} />
		</Text>
	);
}
